import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Directive({
    selector: '[appSpinner]',
    standalone: false
})
export class SpinnerDirective {
  #color: ThemePalette = 'accent';
  #diameter: number = 18;
  #isSpinning: boolean|null = null; // unset by default, this forces it to evaluate upon first render.
  #spinner: MatProgressSpinner|null = null;

  constructor(
    // private componentFactoryResolver: ComponentFactoryResolver,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input()
  set appSpinnerColor(color: ThemePalette) {
    this.#color = color;
    if (this.#spinner) {
      this.#spinner.color = color;
    }
  }

  @Input()
  set appSpinnerDiameter(diameter: number) {
    this.#diameter = diameter;
    if (this.#spinner) {
      this.#spinner.diameter = diameter;
    }
  }

  @Input() set appSpinner(condition: boolean) {
    if (condition !== this.#isSpinning) {
      this.#spinner = null;
      this.viewContainer.clear();
      this.#isSpinning = condition;
      if (!condition) {
        // Render the template
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else if (condition) {
        this.addSpinner();
      }
    }
  }

  private addSpinner() {
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MatProgressSpinner);
    const { instance } = this.viewContainer.createComponent(MatProgressSpinner);
    instance.diameter = this.#diameter;
    instance.color = this.#color;
    instance.mode = 'indeterminate';
    instance._elementRef.nativeElement.classList.add('spinner-instance');
    this.#spinner = instance;
  }

}
